import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlterarSenhaComponent } from './alterar-senha.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { ThemeModule } from '../../@theme/theme.module';
import { NbCardModule } from '@nebular/theme';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [AlterarSenhaComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ThemeModule,
    CommonModule,
    NbCardModule,
    ReactiveFormsModule,
    RouterModule
  ],
})
export class AlterarSenhaModule { }
